import { render, staticRenderFns } from "./AboutBhs.vue?vue&type=template&id=f646258a&scoped=true"
import script from "./AboutBhs.vue?vue&type=script&lang=js"
export * from "./AboutBhs.vue?vue&type=script&lang=js"
import style0 from "./AboutBhs.vue?vue&type=style&index=0&id=f646258a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f646258a",
  null
  
)

export default component.exports